import React from 'react'
import {Box, Button, Stack, Typography} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {StarOutline} from "@mui/icons-material";
import {useAdviceFavorite} from "./hook/useAdviceFavorite";
import {removeHtml, truncateStr} from "../Service";
import {useNavigate} from "react-router-dom";

const AdviceItem = props => {

    const {id, title, description, variant, image, variantName, controls, treading, treadingBadge, isFavorite} = props

    const {addToFavorite, removeFromFavorite} = useAdviceFavorite()

    const nav = useNavigate()

    return <Box className="service-item-container">
        <Stack className="service-item"
             data-variant={variant}
             data-treading={treading && treadingBadge ? 'yes':'no'}
             sx={{
                 ml: {xs : 'auto' , md : 'auto', lg : '0px'},
                 mr: {xs : 'auto' , md : 'auto', lg : '0px'},
                 width: {xs : '310.4px' , md : '330.4px', lg : '330.4px'}
             }}
             gap={'10px'}
        >
            <Box className="service-item__head">
                <Box>
                    <img src={`/assets/icon/${variant}.png`} alt="Image service" className="service-item__icon"/>
                    <Typography variant="subtitle1" component="span">
                        {variantName}
                    </Typography>
                </Box>
                {
                    controls.includes('add-to-fav') && isFavorite &&
                    <Button className="btn btn-fav" onClick={() => removeFromFavorite(id) } >
                        <StarIcon role={'img'} aria-label="Enlever des favoris" />
                        <Typography  variant={'subtitle6'}>Enlever des favoris</Typography>
                    </Button>
                }
                {
                    controls.includes('add-to-fav') && !isFavorite &&
                    <Button className="btn btn-fav" onClick={ () => addToFavorite(id) } aria-label={"Ajouter dans mes favoris"}>
                        <StarOutline role={'img'} aria-label="Ajouter dans mes favoris" />
                        <Typography  variant={'subtitle6'}>Ajouter aux favoris</Typography>
                    </Button>
                }
            </Box>
            <Box className="service-item__image">
                <a href={`/advice/${id}`} className="service-item__img-link" onClick={ e => {
                    e.preventDefault()
                    nav(`/advice/${id}`)
                } } />
            </Box>
            <Box className="service-item__body">
                <Typography variant="subtitle1" className="service-item__title">{title}</Typography>
                <Typography component="p" sx={{margin: "unset"}}>{ truncateStr(removeHtml(description), 120) }</Typography>
            </Box>
            {
                controls.includes('show-detail') &&
                <Button className="btn btn-see-detail" onClick={ () => nav(`/advice/${id}`) } aria-label="Voir le détail du service">
                    <RemoveRedEyeIcon role={'img'} aria-label="Voir le détail du service" />
                    <Typography component="span">Voir le détail</Typography>
                </Button>
            }
        </Stack>
    </Box>
}

AdviceItem.defaultProps = {
    controls: ['add-to-fav', 'show-detail'],
    treadingBadge: false
}

export default AdviceItem
